export default __webpack_public_path__ + "static/RandomGif-8b2f7f5c585b20dba7baafc077d8ef6c.gif";